import React, { useContext, useState, useEffect } from 'react'
import ModalContext from '../../contexts/ModalContext'
import UserContext from '../../contexts/UserContext'
import { usePermissions } from '../../hooks/usePermissions'
import {
  Container,
  CloseDiv,
  HeaderText,
  Input,
  InputDiv,
  InputLabel,
  SelectInputMoviment,
  SelectInputKgOrMm,
  SelectOption,
  CloseImg,
  SwitchesDiv,
  SwitchDiv,
  SwitchLabel,
  SwitchBox,
  SwitchInput,
  SwitchSlider,
  InputText,
  NextButtonDiv,
  NextButtonImage,
  NextButtonText,
  ButtonsDiv,
  WarningDiv,
  WarningText,
  PreviousButtonDiv,
  PreviousButtonImage,
  PreviousButtonText,
  HeaderDiv,
  InputRowDiv,
} from './style'
import StockContext from '../../contexts/StockContext'
import cross from '../../assets/addStockModal/cross.svg'
import diskIcon from '../../assets/addStockModal/pages/disk.svg'
import arrowLeft from '../../assets/addStockModal/pages/arrow-left.svg'
import ApiService from '../../services/ApiService'

const EntryOrExit = () => {
  const { setModalActive, setModalSection, itIsUpdate } = useContext(ModalContext)
  const { stock, setStock, setStockList } = useContext(StockContext)
  const { user } = useContext(UserContext)
  const { canEdit } = usePermissions()
  

  if (!canEdit.stock()) {
    return (
      <Container>
        <HeaderDiv>
          <HeaderText>Acesso Negado</HeaderText>
          <CloseDiv onClick={() => setModalActive(false)}>
            <CloseImg src={cross} alt="close" />
          </CloseDiv>
        </HeaderDiv>
        <WarningDiv>
          <WarningText>Você não tem permissão para editar o estoque.</WarningText>
        </WarningDiv>
        <ButtonsDiv>
          <PreviousButtonDiv onClick={() => setModalActive(false)}>
            <PreviousButtonText>Fechar</PreviousButtonText>
          </PreviousButtonDiv>
        </ButtonsDiv>
      </Container>
    )
  }
  const [movementType, setMovementType] = useState<string>('Entrada')
  const [observation, setObservation] = useState<string>('')
  const [unitOfMeasurement, setUnitOfMeasurement] = useState<string>('KG')
  const [updateInOmie, setUpdateInOmie] = useState<boolean>(false)
  const [updateInStock, setUpdateInStock] = useState<boolean>(false)
  const [warningMessage, setWarningMessage] = useState<string>('')
  const [quantity, setQuantity] = useState<string>('')

  const [totalKg, setTotalKg] = useState<number | null>(null)
  const [totalMm, setTotalMm] = useState<number | null>(null)

  useEffect(() => {
    setWarningMessage('')
  }, [stock, updateInOmie, updateInStock])

  useEffect(() => {
    const currentQuantity = Number(quantity)
    const isNumber = !isNaN(currentQuantity) && isFinite(currentQuantity) && currentQuantity > 0

    if (isNumber) {
      if (movementType === 'Entrada') {
        setTotalKg(
          unitOfMeasurement === 'KG'
            ? Number(stock.totalWeight) + currentQuantity
            : Number(stock.totalWeight)
        )
        setTotalMm(
          unitOfMeasurement === 'MM'
            ? Number(stock.lengthInMm) + currentQuantity
            : Number(stock.lengthInMm)
        )
      } else {
        setTotalKg(
          unitOfMeasurement === 'KG'
            ? Number(stock.totalWeight) - currentQuantity
            : Number(stock.totalWeight)
        )
        setTotalMm(
          unitOfMeasurement === 'MM'
            ? Number(stock.lengthInMm) - currentQuantity
            : Number(stock.lengthInMm)
        )
      }
    } else {
      setTotalKg(null)
      setTotalMm(null)
    }
  }, [quantity, movementType, unitOfMeasurement, stock])

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target

    switch (name) {
      case 'movementType':
        setMovementType(value)
        break
      case 'observation':
        setObservation(value)
        break
      case 'unitOfMeasurement':
        setUnitOfMeasurement(value)
        break
      default:
        setStock({
          ...stock,
          [name]: value,
        })
        break
    }
  }

  const switches: string[] = ['omie', 'updateInStock']
  const switchesText: string[] = [
    unitOfMeasurement === 'KG'
      ? 'Movimentar peso na Omie'
      : 'Movimentar comp. na Omie',
    unitOfMeasurement === 'KG'
      ? 'Movimentar peso no estoque'
      : 'Movimentar comp. no estoque',
  ]
  const switchValues: boolean[] = [updateInOmie, updateInStock]

  const WarningBox = () => {
    if (!warningMessage) return null
    return (
      <WarningDiv>
        <WarningText>{warningMessage}</WarningText>
      </WarningDiv>
    )
  }

  const handleSwitchToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = e.target
    switch (name) {
      case 'omie':
        setUpdateInOmie(!updateInOmie)
        break
      case 'updateInStock':
        setUpdateInStock(!updateInStock)
        break
      default:
        console.warn('Caminho inesperado ao ativar um switch toggle')
        break
    }
  }

  const handleSubmit = async () => {
    if (!quantity.trim()) {
      setWarningMessage('O campo Quantidade não pode estar vazio.')
      return
    }

    if (!updateInOmie && !updateInStock) {
      setWarningMessage('Ative pelo menos uma opção de atualização.')
      return
    }

    setWarningMessage('')

    const newEntry = {
      codeId: stock.codeId,
      movementType,
      quantity: Number(quantity),
      updateInOmie,
      updateInStock,
      observation,
      unitOfMeasurement,
    }

    const token = localStorage.getItem('token')
    try {
      setWarningMessage('Salvando...')


      console.debug('[ModalEntryOrExit] Enviando handle-stock-movement ->', {
        endpoint: '/backend/handle-stock-movement',
        payload: newEntry,
      })

      const response = await ApiService.post('/backend/handle-stock-movement', newEntry)


      console.debug('[ModalEntryOrExit] Resposta handle-stock-movement ->', {
        status: response?.status,
        data: response?.data,
      })

      if (response.status === 201 || response.status === 200) {
        if (updateInStock) {
        setStock({
          ...stock,
          totalWeight: String(totalKg !== null ? totalKg : (stock.totalWeight ?? '')),
          lengthInMm: String(totalMm !== null ? totalMm : (stock.lengthInMm ?? '')),
        })

        if (setStockList) {
          setStockList((prev: any[]) =>
            prev.map((item) =>
              item.codeId === stock.codeId
                ? {
                    ...item,
                    totalWeight: String(totalKg !== null ? totalKg : (item.totalWeight ?? '')),
                    lengthInMm: String(totalMm !== null ? totalMm : (item.lengthInMm ?? '')),
                  }
                : item
            )
          )
        }
      }
        setModalActive(false)
      } else {
        setWarningMessage('Erro inesperado. Tente novamente.')
      }
    } catch (error: any) {
      setWarningMessage(
        error.response?.data?.message || 'Erro ao salvar os dados. Verifique os campos e tente novamente.',
      )
    }
  }

  const productDetailsModal = () => {
    setModalSection('newModal')
  }

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>
          {itIsUpdate
            ? `Novo Movimento - ${stock.description}`
            : 'Adicionar Estoque'}
        </HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>
      <InputRowDiv>
        <InputDiv>
          <InputLabel>Tipo</InputLabel>
          <SelectInputMoviment
            name='movementType'
            value={movementType}
            onChange={(e) => handleSelectChange(e)}
          >
            <SelectOption value='Entrada'>ENTRADA</SelectOption>
            <SelectOption value='Saída'>SAÍDA</SelectOption>
          </SelectInputMoviment>
        </InputDiv>
        <InputDiv>
          <InputLabel>Unidade</InputLabel>
          <SelectInputKgOrMm
            name='unitOfMeasurement'
            value={unitOfMeasurement}
            onChange={(e) => handleSelectChange(e)}
          >
            <SelectOption value='KG'>KG</SelectOption>
            <SelectOption value='MM'>MM</SelectOption>
          </SelectInputKgOrMm>
        </InputDiv>
      </InputRowDiv>
      <br />
      <InputRowDiv>
        <InputDiv>
          <InputLabel>
            {unitOfMeasurement === 'KG' ? 'Peso atual' : 'Comprimento atual'}
          </InputLabel>
          <Input
              value={
                unitOfMeasurement === 'KG'
                  ? (stock.totalWeight ?? '')
                  : (stock.lengthInMm ?? '')
              }
              disabled
            />
        </InputDiv>

        <InputDiv>
          <InputLabel>Quantidade</InputLabel>
          <Input
            placeholder='Digite aqui'
            type='number'
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />
        </InputDiv>
      </InputRowDiv>
      <SwitchesDiv>
        {switches.map((field, index) => (
          <SwitchDiv key={field}>
            <SwitchLabel htmlFor={field}>{switchesText[index]}</SwitchLabel>
            <SwitchBox>
              <SwitchInput
                type='checkbox'
                name={field}
                checked={switchValues[index]}
                onChange={handleSwitchToggle}
              />
              <SwitchSlider className='slider'></SwitchSlider>
            </SwitchBox>
          </SwitchDiv>
        ))}
      </SwitchesDiv>
      <InputRowDiv>
        <InputDiv>
          <InputLabel>Observação</InputLabel>
          <InputText
            name='observation'
            value={observation}
            onChange={(e) => handleSelectChange(e)}
            autoFocus
          />
        </InputDiv>

        <InputDiv style={{ marginLeft: '40px' }}>
          <InputLabel>Total em KG</InputLabel>
          <Input
            value={totalKg !== null && unitOfMeasurement === 'KG' ? totalKg.toFixed(2) : ''}
            disabled
            placeholder='0'
            style={{ height: '40px' }}
          />
          <br />
          <InputLabel>Total em MM</InputLabel>
          <Input
            value={totalMm !== null && unitOfMeasurement === 'MM' ? totalMm.toFixed(2) : ''}
            disabled
            placeholder='0'
            style={{ height: '40px' }}
          />
        </InputDiv>
      </InputRowDiv>
      <ButtonsDiv>
        <WarningBox />
        <PreviousButtonDiv onClick={productDetailsModal}>
          <PreviousButtonImage src={arrowLeft} alt='Right arrow icon' />
          <PreviousButtonText>Voltar</PreviousButtonText>
        </PreviousButtonDiv>
        <NextButtonDiv
          onClick={() => handleSubmit()}
          className={warningMessage !== '' && warningMessage !== 'Salvando...' ? 'disabled' : ''}
        >
          <NextButtonImage src={diskIcon} alt='Right arrow icon' />
          <NextButtonText>Salvar</NextButtonText>
        </NextButtonDiv>
      </ButtonsDiv>
    </Container>
  )
}

export default EntryOrExit

